import { Vector2Tuple, Vector3 } from 'three';

import { closestPointInNavMesh, NavMesh } from '@spazious/dollhouse-navmesh';
import { FShallowGraph, FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import { FSetupGraph } from '../graph/index.js';
import { DecorationNode, FNode, FurnitureNode } from '../types/index.js';

import { getWorldPosition } from './getWorldPosition.js';

const _rayDistance = new Vector3(0.1, 3, 0.1);
const _rayTarget = new Vector3();

type StackableBaseNode = FurnitureNode | DecorationNode;

export const findStackableNode = (
  graph: FSetupGraph,
  shallowGraph: FShallowGraph,
  origin: Vector2Tuple,
  selector: string,
  type: FShallowNodeTypesEnum
): { node: FNode; positionY: number } | null => {
  if (
    ![
      FShallowNodeTypesEnum.Furniture,
      FShallowNodeTypesEnum.Decoration,
      FShallowNodeTypesEnum.FComposition,
    ].includes(type)
  ) {
    return null;
  }

  let stackableNode: FNode | null = null;
  let positionY = 0;
  graph.traverse((node) => {
    if (stackableNode || node.selector === selector) {
      return;
    }
    const navMesh = (node as StackableBaseNode).object?.navMesh as NavMesh;
    if (!navMesh) return;

    const shallowNode = shallowGraph.nodes[node.selector];
    if (
      !shallowNode || // node is deleted in shallow graph
      (shallowNode as any).parent // or, parent is already stacked
    ) {
      return;
    }
    const position = getWorldPosition(node);
    const localPos = [origin[0] - position[0], origin[1] - position[1]];
    _rayTarget.set(localPos[0], 0, localPos[1]);

    const navMeshResult = closestPointInNavMesh(_rayTarget, navMesh.navMeshQuery, {
      distance: _rayDistance,
    });
    if (navMeshResult.success && navMeshResult.isPointOverPoly) {
      stackableNode = node;
      positionY = navMeshResult.point.y;
    }
  });

  return stackableNode ? { node: stackableNode, positionY } : null;
};
